module.exports = __webpack_public_path__ + "static/summer-sunset-c8ded2b7cc7d7fbb9858c3f40dd858d0.jpg";